export const SINGLE_CATALOGUE_FEATURE_KEY = 'single-catalogue';
